/**
 * Labstep
 *
 * @module components/Metadata/Action/Create/File
 * @desc Metadata File Upload Container
 */

import { useHasAccess } from 'labstep-web/components/Entity/Can/hooks';
import { Action } from 'labstep-web/components/Entity/Can/types';
import { FileActionUploadContainer as FileActionUpload } from 'labstep-web/components/File/Action/Upload';
import { EntityCreateContainer } from 'labstep-web/containers/Entity/Create';
import type { File as FileModel } from 'labstep-web/models/file.model';
import { Metadata } from 'labstep-web/models/metadata';
import { MetadataThread } from 'labstep-web/models/metadata-thread.model';
import type React from 'react';
import type { MetadataActionCreateFileProps } from './types';

export const MetadataActionCreateFile: React.FC<
  MetadataActionCreateFileProps
> = ({ metadataThreadId, children }) => {
  const canEdit = useHasAccess(
    MetadataThread.entityName,
    metadataThreadId,
    Action.edit,
  );
  return canEdit ? (
    <EntityCreateContainer
      entityName={Metadata.entityName}
      parentName={MetadataThread.entityName}
      parentId={metadataThreadId}
    >
      {({ create }) => (
        <FileActionUpload
          showDragEnter
          multiple
          noClick
          options={{
            onSuccess: ({ response }) => {
              create({
                label: 'File',
                metadata_thread_id: metadataThreadId,
                type: 'file',
                is_output: true,
                file_id: (
                  (response as Record<string, unknown>)!
                    .result as Record<number, FileModel>
                )[0], // TODO response shape is different from upload endpoint
              });
            },
          }}
          children={children}
        />
      )}
    </EntityCreateContainer>
  ) : (
    children
  );
};
